import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { useFlag } from '@unleash/proxy-client-react';

import { ReactComponent as CompanyLogo } from '../assets/images/company_name.svg';
import { ReactComponent as MaintenanceSVG } from '../assets/images/maintenance.svg';

export const Maintenance: React.FC<PropsWithChildren> = ({ children }) => {
  const maintenance = useFlag('wsc.offline');
  return maintenance ? <MaintenanceScreen /> : <>{children}</>;
};

const MaintenanceScreen: React.FC = () => {
  return (
    <Wrapper>
      <LogoContainer>
        <CompanySVG />
      </LogoContainer>

      <MaintenanceIconContainer>
        <MaintenanceSVG />
      </MaintenanceIconContainer>

      <Text>
        Thank you for your patience as we perform routine site maintenance. We expect to be back
        shortly.
      </Text>
      <Text>
        Wir führen gerade eine Routinewartung unserer Website durch. Vielen Dank für Ihr
        Verständnis. Die Website sollte in Kürze wieder voll verfügbar sein.
      </Text>
      <Text>
        Nous vous remercions de votre patience pendant que nous effectuons la maintenance de routine
        du site. Nous espérons revenir bientôt.
      </Text>
      <Text>
        Wij danken u voor uw geduld terwijl wij routineonderhoud aan de site uitvoeren. We hopen
        snel weer terug te zijn.
      </Text>
      <Text>
        Te agredecemos tu paciencia mientras realizamos el mantenimiento rutinario del sitio.
        Esperamos estar de vuelta muy pronto.
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  > * + * {
    margin-top: 2rem;
  }
`;

const LogoContainer = styled.div`
  text-align: center;
  padding: 1rem 0 0.5rem;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.brand100};
`;

const CompanySVG = styled(CompanyLogo)`
  width: 15%;
  height: 15%;
  .st0 {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

const MaintenanceIconContainer = styled.div`
  width: 20%;
  height: 20%;
`;

const Text = styled.p`
  font-weight: 600;
  font-size: 1.25rem;
  width: 60%;
  text-align: center;
`;
